import React from 'react';
import { CodeIcon, PenToolIcon, GlobeIcon, LayersIcon } from 'lucide-react';
export const Skills = () => {
  const skills = [{
    category: '开发技能',
    icon: <CodeIcon size={24} className="text-red-700" data-id="element-160" />,
    items: ['React', 'TypeScript', 'webpack', 'git']
  }, {
    category: ' 语言',
    icon: <GlobeIcon size={24} className="text-red-700" data-id="element-161" />,
    items: ['English (Fluent)', '中文', '抚州话']
  }, {
    category: '其他花里胡哨的东西',
    icon: <LayersIcon size={24} className="text-red-700" data-id="element-162" />,
    items: ['英雄联盟佐伊玩家', '羽毛球菜鸡玩家', '探索中...']
  }];
  return <section id="skills" className="py-16" data-id="element-163">
      <div className="container mx-auto px-4" data-id="element-164">
        <div className="text-center mb-12" data-id="element-165">
          <h2 className="text-3xl font-light text-stone-800 mb-2 inline-block border-b-2 border-red-700 pb-1" data-id="element-166">
            技能点
          </h2>
          <p className="text-sm text-stone-500" data-id="element-167">会点啥</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-168">
          {skills.map((skillGroup, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-sm border border-stone-100 hover:shadow-md transition-shadow duration-300" data-id="element-169">
              <div className="flex items-center mb-4" data-id="element-170">
                {skillGroup.icon}
                <h3 className="text-lg text-stone-800 ml-2" data-id="element-171">
                  {skillGroup.category}
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-172">
                {skillGroup.items.map((skill, idx) => <li key={idx} className="flex items-center" data-id="element-173">
                    <span className="w-2 h-2 bg-indigo-900/80 rounded-full mr-2" data-id="element-174"></span>
                    <span className="text-stone-600" data-id="element-175">{skill}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
};